<template>
	<div class="edit_spec-div">
		<div class="tab_div">
			<span class="sku_img">规格图片</span>
			<div class="other">
				<div class="span">
					<el-input class="tab_input" v-model="formData.spec_name1" placeholder="属性一" />
				</div>
				<div class="span">
					<el-input class="tab_input" v-model="formData.spec_name2" placeholder="属性二" />
				</div>
				<span class="span">单位数量</span>
				<span class="span">成本价</span>
				<span class="span">销售价</span>
				<span class="span">划线价</span>
				<span class="span">编码</span>
				<span class="span">库存量</span>
                <span class="span">重量/kg</span>
                <span class="span">体积/cm³</span>
				<span class="span">税率(%)</span>
				<span class="span">操作</span>
			</div>
		</div>
		<div class="list_div">
			<div class="item_div" v-for="(item,index) in formData.skus">
				<multiUpload :type='index' :limitImg='1' :noneBtnImg='item.skuImgList.length > 0' :fileList="item.skuImgList" @saveImg="saveImg" @delImg="delImg" />
				<div class="item_col-div">
					<div class="item_row-div">
						<div class="span"> <el-input class="input" v-model="item.spec_val1" placeholder="如:白色" /> </div>
						<div class="span"> <el-input class="input" v-model="item.spec_val2" placeholder="如:40码" /> </div>
						<div class="span"> <el-input class="input" v-model="item.unit_quatity" placeholder="0" /> </div>
						<div class="span"> <el-input class="input" v-model="item.cost_price" placeholder="0" /> </div>
						<div class="span"> <el-input class="input" v-model="item.sale_price" placeholder="0" /> </div>
						<div class="span"> <el-input class="input" v-model="item.crossed_price" placeholder="0" /> </div>
						<div class="span"> <el-input class="input" v-model="item.brcode" placeholder="0" /> </div>
						<div class="span"> <el-input class="input" v-model="item.stock" placeholder="0" /> </div>
                        <div class="span"> <el-input class="input" v-model="item.weight" placeholder="0" /> </div>
                        <div class="span"> <el-input class="input" v-model="item.volume" placeholder="0" /> </div>
						<div class="span"> <el-input class="input" v-model="item.tax_rate" placeholder="0" /> </div>
						<div class="span" style="display: flex;flex-direction: column;">
							<el-button type="primary" plain @click="addItem(index+1)">添加</el-button>
							<el-button v-if="formData.skus.length > 1" type="danger" plain style="margin: 10px 0 0 0;z-index: 9;" @click="deleteItem(index)">删除</el-button>
						</div>
					</div>
                    <div>
                        <div>
                            <el-checkbox v-model="item.package_switch" :true-label="1" :false-label="0">组合商品</el-checkbox>
                            <span class="_color" style="cursor: pointer;margin-left: 20px;" @click="addPackage(item)">+添加</span>
                        </div>
                        <el-table :data="item.package" size="mini" :header-cell-style="{ background:'#f5f5f5'}" style="width: 100%" max-height="500px" >
                            <el-table-column label="商品名称" prop="good_name"/>
                            <el-table-column label="规格名称" prop="spec_data_str"/>
                            <el-table-column label="数量" prop="quatity">
                                <template v-slot="{row}">
                                    <el-input-number v-model="row.quatity" :min="1" :max="100" size="small"></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column label="成本价" prop="cost_price"/>
                            <el-table-column label="销售价" prop="sale_price"/>
                            <el-table-column label="操作" align="center">
                                <template v-slot="{row}">
                                    <div class="red" style="cursor: pointer;margin-left: 20px;" @click="delPackage(item, row.sku_id)">-删除</div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
				</div>
			</div>
		</div>

        <el-dialog title="选择商品" :visible="goodsShow" width="80%" center append-to-body @close="goodsShow=false">
            <GoodSelect v-model="currentSKu.package" @close="goodsShow=false"></GoodSelect>
        </el-dialog>
	</div>
</template>

<script>
	import multiUpload from "../multiUpload/multiUpload.vue";
    import GoodSelect from "@/components/select/GoodSelect.vue"
	export default {
		components:{ multiUpload, GoodSelect },
		props: {
			formData: {
				type: Object
			}
		},
		data() {
			return {
				value: '',
                goodsShow: false,
                currentSKu: {},
			}
		},
		methods: {
			//添加规格条目
			addItem(index) {
				var obj = {
					skuImgList:[],
					cover_img: '', //规格图片
					spec_val1: '', //规格一
					spec_val2: '', //规格二
					unit_quatity: '', //单位数量
					cost_price: '', //成本价
					sale_price: '', //销售价
					crossed_price: '', //划线价
					brcode: '', //条形码
					stock: '', //库存
					tax_rate: '' //税率
				}
				this.formData.skus.splice(index, 0, obj)
			},

			//删除规格类目
			deleteItem(index) {
				this.formData.skus.splice(index, 1)
			},
			
			//图片存储
			saveImg(arr) {
				this.formData.skus[arr[1]].cover_img = arr[0];
			},
			
			//图片删除
			delImg(arr) {
				this.formData.skus[arr[1]].cover_img = ''
				this.formData.skus[arr[1]].skuImgList = []
			},

            addPackage(item){
                this.currentSKu = item;
                this.goodsShow = true;
            },
            delPackage(item, sku_id){
                item.package = item.package.filter(i => i.sku_id != sku_id)
            },
		}
	}
</script>

<style scoped>
	.edit_spec-div {
		display: flex;
		flex-direction: column;
	}

	.tab_div {
		display: flex;
		flex-direction: row;
		align-items: center;
		background: #f5f5f5;
	}

	.tab_input {
		width: 80px;
	}
	
	.sku_img{
		display: flex;
		justify-content: center;
		width: 195px;
	}
	
	.other{
		display: flex;
		justify-content: space-between;
		width: calc(100% - 195px);
		padding-right: 20px;
	}

	.span {
		display: flex;
		justify-content: center;
		min-width: 100px;
	}

	/deep/.tab_input .el-input__inner {
		width: 80px;
		height: 30px;
	}

	.list_div {
		display: flex;
		flex-direction: column;
		padding: 0 0 20px 0;
	}

	.item_div {
		display: flex;
		flex-direction: row;
		width: calc(100% - 40px);
		padding: 20px 20px 0 0px;
		border-bottom: 1px solid #f5f5f5;
	}

	.item_col-div {
		display: flex;
		flex-direction: column;
		width: 100%;
	}

	.item_row-div {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.input {
		width: 100px;
	}
	
	.upload_div {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100px;
		height: 100px;
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
	}

	.el-icon-plus {
		font-size: 20px;
		font-weight: bolder;
		color: #606266;
	}
</style>